import { QueryClient } from '@tanstack/react-query'
import { registerClient } from '@/scopes/common/infrastructure/query-client/queryClientsRegistry'

export const SEARCH_QUERY_RETRY_COUNT = 3

export const searchQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: SEARCH_QUERY_RETRY_COUNT,
      staleTime: 60 * 1000,
    },
  },
})

registerClient(searchQueryClient)
